<template>
  <FreeSlider
    ref="sliderRef"
    :configs="sliderConfigs"
    class="py-4"
    @change:modelValue="onChange"
  >
    <template #title>
      <h2 class="text-text-neutral-primary text-lg font-semibold">
        {{ title }}
      </h2>
    </template>
    <template #labels="{ labels }">
      <div
        class="text-text-neutral-tertiary flex w-full justify-between font-medium"
      >
        <p>{{ formatLabel(labels[0]) }}</p>
        <p>{{ formatLabel(labels[1]) }}</p>
      </div>
    </template>
  </FreeSlider>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue';
  import { FreeSlider } from 'freedom-shared';
  import { debounce } from 'lodash-es';

  const props = defineProps<{
    title: string;
    state: number[];
  }>();

  const emit = defineEmits<{
    onUpdate: [newFlightTime: number[]];
  }>();

  const sliderRef = ref<InstanceType<typeof FreeSlider>>();
  const sliderStart = computed(() =>
    props.state.length === 2 ? props.state : [0, 24],
  );
  const sliderConfigs = computed(() => ({
    start: sliderStart.value,
    margin: 1,
    step: 0.5,
    connect: [false, true, false],
    range: {
      min: [0],
      max: [24],
    },
  }));

  function onUpdate(value: number[]) {
    const [min, max] = props.state;
    const [newMin, newMax] = value;

    if (min !== +newMin || max !== +newMax) {
      emit('onUpdate', value);
    }
  }

  const formatLabel = (label: number | string) => {
    if (!label) {
      return '';
    }
    const [int, decimal] = label.toString().split('.');
    const decimalText = parseInt(decimal) === 50 ? '30' : '00'; // If decimal part equals 50, i.e 0.5 then it is half an hour
    return `${int}:${decimalText}`;
  };

  const debounceChange = debounce(onUpdate, 300);

  function onChange(value: number[]) {
    debounceChange(value);
  }

  watch(
    () => props.state,
    newState => {
      sliderRef.value?.sliderAPI?.set(newState);
    },
    { deep: true },
  );
</script>
